import { useLegacyDialogProps } from 'components/DialogV3/DialogManagerContext';
import { Box, Button, DialogActions, DialogContent, DialogContentText, FormHelperText, MenuItem, Select, Typography } from '@mui/material';
import DateRangePickerCC from 'components/common/DateRangePickerCC';
import TextFieldVMP from 'components/common/TextField/TextFieldVMP';
import DialogBaseCC from 'components/Dialog/DialogBaseCC';
import moment from 'moment';
import { handleValidateInput } from 'pages/manager-roles/hooks/useHandleValidateInput';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { setCloseDialogCC } from 'utils/helpers';
import { DIALOG_ID } from './constant';
import { TimePickerCC } from 'pages/manager-meeting/components/TimePickerCC';
import { convertHourAndMinToSecond, convertSecondToHourAndMinute } from 'pages/manager-meeting/functions';

const DialogEditRoleItem = () => {
    const propsDialog = useLegacyDialogProps();
    const { title, item, onClick} = propsDialog;
    const [newItem, setNewItem] = useState(
        {
            code: "",
            name: "",
            description: "",
            is_active: "",
            data_type: "",
            default_value: "",
            value: "",
            requires: "",
            groups: ""
        }
    );
    const [checkValidStartTimeSecond, setCheckValidStartTimeSecond] = useState(true);
    const [valueDate, setValueDate] = useState({
        day: moment(),
        hourAndMinute: convertHourAndMinToSecond(moment().format("HH:mm"))
    });
    const {t} = useTranslation('pgRole');
    const [isRefresh, setIsRefresh] = useState(true)
    const [errorValid, setErrorValid] = useState(() => handleValidateInput(newItem, t));
    const [clickSubmit, setClickSubmit] = useState(false);

    const handleNewItem = (values) => {
        setClickSubmit(true);
        
        if(errorValid['value'].value){
            return;
        }

        if(parseInt(newItem?.data_type) === 4 ){
            if(checkValidStartTimeSecond){
                const convertTime = moment(valueDate.day).startOf('day').add(valueDate.hourAndMinute, 'seconds').unix();
                onClick({
                    ...values,
                    value: convertTime
                })
            }
        } else {
            onClick(values)
        }
    }

    const renderContent = (data_type) => {
        switch (data_type) {
            case 0:
                return(
                    <Select
                        fullWidth   
                        value={parseInt(newItem?.value)}
                        onChange={(event) => {
                            setNewItem({
                                ...newItem,
                                value: event.target.value
                            })
                        }}
                        sx={{ maxHeight: '36px', width: { xs: 'auto', xl: '200px' } }}
                    >
                        <MenuItem key={'1'} value={1}>TRUE</MenuItem>
                        <MenuItem key={'0'} value={0}>FALSE</MenuItem>
                    </Select>
                )
            case 1: 
                return (
                    <TextFieldVMP 
                        inputRef={(input) => input && input.focus()}
                        onFocus={(e) =>
                            e.currentTarget.setSelectionRange(
                            e.currentTarget.value.length,
                            e.currentTarget.value.length
                        )}
                        error={clickSubmit && errorValid['value']?.value} 
                        helperText={clickSubmit && t(errorValid['value']?.helperText)}  
                        multiline
                        maxRows={4}
                        type="text"
                        value={newItem.value}
                        onChange={e => {
                            setNewItem({
                                ...newItem,
                                value: e.target.value
                            })
                        }}
                    />
                )
            case 2: 
            case 3:
                return (
                    <TextFieldVMP
                        autoFocus={true}
                        error={clickSubmit && errorValid['value']?.value} 
                        helperText={clickSubmit && t(errorValid['value']?.helperText)}  
                        type="number"
                        value={newItem.value}
                        onChange={e => {
                            setNewItem({
                                ...newItem,
                                value: e.target.value
                            })
                        }}
                    />
                )
                case 4:
                    return(
                        <Box>
                            <Box sx={{display: 'flex', alignItems: 'center'}}>
                                <Box sx={{width: '50%', marginRight: '1rem'}}>
                                    {
                                        isRefresh &&
                                        <DateRangePickerCC
                                            inputId="input-daterange-schedulemeeting-1"
                                            containerClass={`daterange-container`}
                                            timePicker={valueDate.day}
                                            setTimePicker={(object) => {
                                                setValueDate({
                                                    ...valueDate,
                                                    day: object.startDate
                                                })
                                            }}
                                            initialSettingsProps={{
                                                singleDatePicker: true,
                                                showDropdowns: true,
                                            }}
                                        />
                                     }
                                </Box>
                                <Box sx={{width: '30%'}}>
                                    <TimePickerCC
                                        id={'timepicker-start'}
                                        validTime={checkValidStartTimeSecond}
                                        value={convertSecondToHourAndMinute(valueDate.hourAndMinute)}
                                        setValue={(_time) => {
                                            let time = convertHourAndMinToSecond(_time);
                                            
                                            if (time || time === 0) {
                                                setCheckValidStartTimeSecond(true);
                                                setValueDate({
                                                    ...valueDate,
                                                    hourAndMinute: time
                                                })
                                            } else {
                                                setCheckValidStartTimeSecond(false);
                                            }
                                        }}
                                    />
                                </Box>
                            </Box>
                            <FormHelperText
                                style={{
                                    color: '#d32f2f',
                                }}
                            >
                                {(!checkValidStartTimeSecond) && t('meeting.validTime')}
                            </FormHelperText>
                        </Box>
                    )
            default:
                break;
        }
    }

    useEffect(() => {
        setErrorValid((prev) => handleValidateInput(newItem, t));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [newItem]);

    useEffect(() => {
        setClickSubmit(false);
        setNewItem({
            ...item,
            value: item?.value || item?.default_value
        });
        if(parseInt(item?.data_type) === 4){
            setCheckValidStartTimeSecond(true)
            setIsRefresh(false)
            setValueDate({
                day: {startDate: moment.unix(item?.value || item?.default_value).startOf('day')},
                hourAndMinute: convertHourAndMinToSecond(moment.unix(item?.value || item?.default_value).format("HH:mm"))
            })
            setIsRefresh(true)
        }

    }, [item])

    return (
        <DialogBaseCC id={DIALOG_ID.EDIT_ROLE_ITEM} title={title}>
            <DialogContent >
                <DialogContentText sx={{maxWidth: '100% !important'}}>
                    <Box sx={{marginTop: '11px', wordBreak: 'break-all'}}>
                        {t('table.roleCode')}: <span style={{fontWeight: '700'}}>{item?.code}</span>
                    </Box>
                    <Box sx={{ wordBreak: 'break-all'}}>
                        {t('table.roleName')}: {item?.name}
                    </Box>
                    <Box sx={{marginTop: '1rem'}}>
                        <Typography sx={{marginBottom: '5px'}}>{t('common:label.value')}</Typography>
                        <Box>
                            {renderContent(newItem?.data_type)}
                        </Box>
                    </Box>
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button variant='outlined' onClick={setCloseDialogCC}>{t('button.cancel')}</Button>
                <Button onClick={() => {handleNewItem(newItem)}}>{t('button.updateRoleFunc')}</Button>
            </DialogActions>
        </DialogBaseCC>
    )
}

export default DialogEditRoleItem
